import type {NotificationsStore} from '../store/notifications.store';

export const selectSelectedTab = (state: NotificationsStore) => state.selectedTab;
